/**
 * Returns true if a date-only string (e.g. "2026-01-18") represents a date
 * that is strictly before today (yesterday or earlier), using local time.
 * Today itself is considered valid (selectable).
 *
 * Avoids the UTC-midnight trap: `new Date("2026-01-18")` parses as UTC
 * midnight which can incorrectly land "yesterday" in negative-UTC
 * timezones.
 *
 * Shared across features — audit creation, audit reopen, and task
 * due-date pickers all disable past dates with the same rule.
 */
export function isDateBeforeToday(dateStr: string): boolean {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  // Defaults guard against malformed input under noUncheckedIndexedAccess;
  // upstream validation ensures a complete YYYY-MM-DD string in practice.
  const [y = 0, m = 1, d = 1] = dateStr.split('-').map(Number);
  const picked = new Date(y, m - 1, d);
  return picked < today;
}
